export const shell = {
  skipToContent: 'Pular para o conteúdo',
  navLabel: 'Navegação principal',
  openMenu: 'Abrir menu',
  closeMenu: 'Fechar menu',
  collapse: 'Recolher menu',
  expand: 'Expandir menu',
  search: 'Buscar cliente, página ou ação',
  notifications: 'Notificações',
  preferences: 'Preferências',
  accountMenu: (name: string) => `Conta de ${name}`,
  profile: 'Meu perfil',
  myDashboard: 'Meu painel',
  firstSteps: 'Primeiros passos',
  firstStepsPending: 'Primeiros passos, há itens pendentes',
  replayTour: 'Ver o tour de novo',
  signOut: 'Sair',
  version: (sha: string, date: string) => `Versão ${sha} de ${date}`,
  versionNoDate: (sha: string) => `Versão ${sha}`,
  versionDev: 'Versão de desenvolvimento',
  newVersion: 'Nova versão disponível.',
  newVersionReload: 'Recarregar',
  compact: 'Compactar',
  compactOn: 'Compactar o layout para meia tela',
  compactOff: 'Voltar ao layout normal',
  agreementsPendingBadge: (n: number) =>
    n === 1 ? '1 proposta aguardando aprovação' : `${n} propostas aguardando aprovação`,
  install: {
    menuItem: 'Instalar o app',
    installed:
      'App instalado. Ele abre numa janela própria, pelo menu Iniciar ou pela barra de tarefas.',
    dismissed: 'Instalação cancelada. O botão continua no menu da conta.',
    dialogTitle: 'Instalar o app',
    dialogDescription:
      'Instalado, o CRM abre numa janela própria, fica na barra de tarefas e mostra no ícone quantas notificações e lembretes esperam por você.',
    unsupported:
      'Este navegador não ofereceu a instalação automática. Siga os passos do seu navegador:',
    edgeTitle: 'Microsoft Edge',
    edgeSteps: [
      'Abra o menu Configurações e mais (os três pontos no canto superior direito).',
      'Escolha Aplicativos e depois Instalar este site como um aplicativo.',
      'Confirme em Instalar.',
    ],
    chromeTitle: 'Google Chrome',
    chromeSteps: [
      'Clique no ícone de instalar, à direita da barra de endereço.',
      'Sem o ícone: menu (os três pontos) › Transmitir, salvar e compartilhar › Instalar página como app.',
      'Confirme em Instalar.',
    ],
    otherBrowsers: 'Em outros navegadores, abra o sistema no Edge ou no Chrome para instalar.',
    close: 'Fechar',
  },
  palette: {
    title: 'Paleta de comandos',
    placeholder: 'Buscar cliente, página ou ação',
    empty: 'Nenhum resultado. Tente outro termo.',
    navigate: 'Navegar',
    actions: 'Ações',
    customers: 'Clientes',
    customersHint: 'Digite ao menos 3 letras para buscar clientes por nome, CPF ou matrícula.',
    /** Com `cases.write` ou `sales.write`, a busca também acha o telefone (8 dígitos ou mais). */
    customersHintPhone:
      'Digite ao menos 3 letras para buscar clientes por nome, CPF, matrícula ou telefone.',
    customersLoading: 'Buscando clientes…',
    customersEmpty: 'Nenhum cliente encontrado com esse termo.',
    themeLight: 'Usar tema claro',
    themeDark: 'Usar tema escuro',
    themeSystem: 'Usar o tema do sistema',
    densityCompact: 'Usar densidade compacta',
    densityComfortable: 'Usar densidade confortável',
    exportCases: 'Exportar carteira',
    newCustomer: 'Novo cliente',
    importSheet: 'Importar planilha',
    newView: 'Nova visão',
    newLead: 'Novo lead',
  },
  preferenceError: 'A preferência não foi salva. Tente de novo.',
  unsaved: {
    title: 'Sair sem salvar?',
    description: 'Você tem alterações não salvas. Se sair agora, elas se perdem.',
    stay: 'Continuar editando',
    leave: 'Sair sem salvar',
  },
} as const
